var map = {
	"./Features-Block-Reviews-DA-DK-D.png": 73690,
	"./Features-Block-Reviews-DE-DE-D.png": 77059,
	"./Features-Block-Reviews-EN-GB-D.png": 81341,
	"./Features-Block-Reviews-EN-US-D.png": 87026,
	"./Features-Block-Reviews-ES-ES-D.png": 1817,
	"./Features-Block-Reviews-ES-MX-D.png": 27802,
	"./Features-Block-Reviews-FR-FR-D.png": 98893,
	"./Features-Block-Reviews-IT-IT-D.png": 72355,
	"./Features-Block-Reviews-NB-NO-D.png": 33380,
	"./Features-Block-Reviews-NL-NL-D.png": 32565,
	"./Features-Block-Reviews-PL-PL-D.png": 14121,
	"./Features-Block-Reviews-PT-BR-D.png": 84881,
	"./Features-Block-Reviews-PT-PT-D.png": 52233,
	"./Features-Block-Reviews-SV-SE-D.png": 99944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89939;